import React from 'react';
import './Styles/media.css';
import MediaOne from './Images/media-one.png';
import MediaTwo from './Images/media-two.png';
import MediaThree from './Images/media-three.png';
import MediaFour from './Images/media-four.png';
import Rating from './Images/star-ratings.png';

const Media = () => (
  <section className="media-wrapper" style={{ borderBottom: '10px solid #f8f8f8' }} aria-labelledby="homepage-networking-title">
    <div className="media-section">
      <h2 id="homepage-networking-title">Du bist richtig bei uns! Wir vernetzen und matchen Dich.</h2>
      <p style={{ maxWidth: '840px', margin: '16px auto 0', lineHeight: '1.7' }}>
        PMPonline bringt Akteure aus Fortbildung, Versorgung und Industrie zusammen und macht relevante
        Angebote zentral auffindbar.
      </p>
      <hr
        style={{
          backgroundColor: '#355fb3',
          width: '240px',
          height: '2px',
          border: 'none',
          marginTop: '15px'
        }}
      />
        <br />
        <br />

    </div>
  </section>
);

export default Media;
